import React from 'react';
import { FormikInput, NonFormikInput } from './FormInput.styled';

const FormInput = ({ ...props }) => <FormikInput {...props}></FormikInput>;

export const Input = ({ ...props }) => <NonFormikInput {...props}></NonFormikInput>;

export default FormInput;
